
import { useNavigate } from 'react-router-dom';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './misc.module.scss';

export default function Produkte() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    //const auth = useSelector((state: RootState) => state.authSlice.auth);
    const navigate = useNavigate();

    return (
        <>
            <div style={{ minHeight: "100vh", margin: "0", display: "flex", flexDirection: "column" }}>
                <div className={styles.bwrapper}>
                    <div className="container">

                        {/*auth.isAuthCheckFinished === false &&
                        <><div>Lädt...</div></>
                    */}

                        <LandingpageHeader />

                        <div>

                            <button className="btn btn-dark" onClick={() => { navigate("/") }}><i className="bi bi-house"></i></button>

                            <div style={{ marginTop: "5em" }}>
                                <h3 style={{ textAlign: "center" }}>Impressum</h3>
                            </div>

                            <div style={{ marginTop: "4em", display: "grid" , gridTemplateColumns: "0.2fr 0.8fr"}}>
                                <div>
                                    <a className={styles.ba} href="#hinschg">Hinweisgeberschutzgesetz</a>
                                </div>
                                <div>
                                    <h3 id="hinschg" style={{textAlign: "center"}}>Hinweisgeberschutzgesetz</h3>

                                    Wir bieten auf Wunsch eine Plattform für ihr Unternehmen an, wo Hinweisgeber anonym einen Hinweis an ihren Hinweisbeauftragten geben können.
                                    <br /><br />
                                    Der Hinweisgeber kann über ein Formular die entsprechenden Informationen ausfüllen und absenden. Danach bekommt er einen für diesen Hinweis
                                    individuellen Code, über dem er über den Status seines Hinweises informiert wird.
                                    <br /><br />
                                    Die Hinweisbeauftragten in ihrem Unternehmen erhalten Zugang zu unserer Plattform, wo nur sie die Hinweise sehen und den Status
                                    dazu ändern können.
                                    <br /><br />
                                    Das Hinweisgeberschutzgesetz ( HinSchG ) trat am 02. Juli 2023 in Kraft	und ist für Unternehmen ab 50 bis 250 Mitarbeiter seit dem 17. Dezember 2023
                                    verpflichtend.
                                    <br /><br />
                                    Für Unternehmen mit bis zu 250 Mitarbeiter bieten wir die Plattform für jährlich 150 EUR an.
                                </div>
                            </div>
                        </div >


                    </div >
                </div>
                <Footer />
            </div >
        </>
    );
}
